<script setup>
import { onMounted, computed, ref, nextTick } from 'vue';
import { useSettingsStore } from '@/stores/storeSettings';
import { useRequestsStore } from '@/stores/storeRequests';
import { useScrollStore } from '@/stores/storeScroll';
import { useFieldsStore } from '@/stores/storeFieldData';
import { useRoute, useRouter } from 'vue-router';
import TheModals from '@/components/blocks/TheModals.vue'
import BaseCookies from '@/components/blocks/BaseCookies.vue'


const storeSettings = useSettingsStore();
const storeRequests = useRequestsStore();
const storeField = useFieldsStore();
const storeScroll = useScrollStore();
const route = useRoute();

const isStubPage = import.meta.env.VITE_SHOW_STUB === "true";

const isDark = computed(() => window.matchMedia("(prefers-color-scheme: dark)").matches);

onMounted( async() => {
	await nextTick();
	
	if(storeRequests.isAuthenticated) {			
		storeField.updateFields("firstName", "disabledBtn", true);
		storeField.updateFields("lastName", "disabledBtn", true);
		storeField.updateFields("phone", "disabledBtn", true);
		storeField.updateFields("email", "disabledBtn", true);
	};
	
	if(isDark.value) {
		document.documentElement.classList.add("dark")
	}	
	
})

</script>

<template>	
	<div :class="['wrapper']">		
		<main class="main">
			<RouterView/>
		</main>	
	</div>	
	<TheModals v-if="!isStubPage"/>	
	<!-- <BaseCookies v-if="!isStubPage"/>		 -->
</template>

<style type="scss" scoped>

</style>
